<template>
  <v-layout :class="styles" column>
    <v-menu transition="slide-y-transition" top>
      <template v-slot:activator="{ on }">
        <p class="ma-0 px-4 notifyTitle">
          <a v-on="on">
            <span v-if="isBefore('2025-04-26')">
              [障害復旧情報] 登録・編集等に失敗する事象について</span
            >
            <span v-else>[お知らせ] GWスケジュールについて</span>
          </a>
        </p>
      </template>
      <v-card class="pa-2">
        <div v-if="isBefore('2025-04-26')" class="pa-2">
          <v-subheader :class="[headerStyles, 'px-2']">
            【障害復旧情報】登録・編集等に失敗する事象について
          </v-subheader>
          <p class="ma-2 incidentRestorationTitle">
            管理画面内において、登録・編集等に一部で失敗する事象が、4月24日（木）15:00
            - 20:00頃に発生しておりました。<br /><br />
            なお現在は復旧しており、正常に保存できるようになっております。<br />ご迷惑をおかけし申し訳ございませんでした。
          </p>
        </div>
        <v-divider v-if="isBefore('2025-04-26')" class="my-2" />
        <div class="pa-2">
          <v-subheader :class="[headerStyles, 'px-2']">
            [お知らせ] GWスケジュールについて
          </v-subheader>
          <p class="ma-2">
            誠に勝手ながら、以下の期間につきましてゴールデンウィーク休業に伴い、各種業務を休止いたします。<br /><br />

            <strong>休業期間</strong><br />
            2025年4月29日(火)<br />
            2025年5月3日(土)〜2025年5月7日（水）<br />
            ※2025年5月7日は会社の定める一斉休業日になります。<br /><br />
            <strong>停止する業務</strong><br />
            ・予算承認業務<br />
            ・各種運用サポート業務<br />
            ・マネージドメニューの入稿業務（動画・音声クリエイティブの入稿代行業務含む）<br />
            ・運用代行業務<br />
            <br />
            上記に伴い、各種入稿スケジュールについて締め切り期限を設定しております。<br />
            詳しくは、<a
              href="https://geologic.atlassian.net/wiki/spaces/GLAD/blog/2025/03/27/3048439809/2025"
              target="_blank"
              rel="noopener"
              ><strong>こちらのページ</strong></a
            >
            にてご確認をお願いします。<br />
            お手数ですが、ご確認の上、期日に間に合うスケジュールにてご入稿、運用依頼のご手配をいただけますようご協力をお願いいたします。<br />
          </p>
        </div>
        <AppButtonOk small>閉じる</AppButtonOk>
      </v-card>
    </v-menu>
  </v-layout>
</template>

<script>
import { css } from 'emotion'
import dayjs from 'dayjs'

export default {
  name: 'HolidaysInformation',
  computed: {
    styles() {
      return css`
        display: flex;
        align-items: flex-start;
        justify-content: center;
        font-size: 12px;
        overflow: hidden;
      `
    },
    headerStyles() {
      return css`
        font-size: 16px !important;
      `
    },
  },
  methods: {
    isBefore(datetime) {
      return dayjs().isBefore(datetime)
    },
  },
}
</script>

<style scoped>
.notifyTitle {
  font-size: 14px;
}
</style>
